export default __webpack_public_path__ + "static/media/arrow-up.0ac77a63.svg";